module.exports = __webpack_public_path__ + "img/delivery-truck-time.3175750b.svg";